/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { Grid, DialogContentText } from '@mui/material';
import { withRouter } from 'react-router-dom';
import * as Roles from '../../../constants/role';
import * as actionsProcedimentosNormas from '../../../store/procedimentosNormas/actions';
import * as selectorsProcedimentosNormas from '../../../store/procedimentosNormas/reducer';
import * as selectorsAuth from '../../../store/auth/reducer';
import {
  InputV2,
  DialogDefaultV2,
  UsuarioSelectV2,
  DefaultSelectV2,
  OptionSelectV2,
  ArquivoContainerV2,
  RichTextEditorV2,
} from '../../../components/v2';
import moment from 'moment';
import { tipoServicoTemSubtipo } from 'utils';

const createSchema = {
  usuarioIds: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  title: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  moduloId: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const cancelSchema = {
  justificativaCancelamento: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const Formulario = ({
  createProcedimentosNormas,
  updateProcedimentosNormas,
  findProcedimentosNormasById,
  procedimentosNormasClearSelected,
  procedimentosNormasCancelStatus,
  procedimentosNormasConfirmStatus,
  selectedProcedimentosNormas,
  open,
  id,
  onClose,
  authData,
  userRole,
  onReload,
}) => {
  const [values, setValues] = useState({});
  const [cancelValues, setCancelValues] = useState({});
  const [openAceitar, setOpenAceitar] = useState(false);
  const [openCancelar, setOpenCancelar] = useState(false);
  const [errors, setErrors] = useState({});
  const [cancelErrors, setCancelErrors] = useState({});

  const getDefaultValues = () => ({
    criadoPorId: authData.id,
    criadoPorNome: authData.nome,
    status: 'AVAILABLE',
  });

  useEffect(() => {
    if (open && !id) {
      setValues(getDefaultValues());
      setCancelValues({});
    }
  }, [id, open]);

  useEffect(() => {
    if (id) {
      findProcedimentosNormasById(id);
    }
  }, [id, findProcedimentosNormasById]);

  useEffect(() => {
    if (selectedProcedimentosNormas && selectedProcedimentosNormas.id) {
      setValues({
        ...selectedProcedimentosNormas,
        dataCriacao: moment(selectedProcedimentosNormas.dataCriacao).valueOf(),
      });
    }
  }, [selectedProcedimentosNormas]);

  const disabled = !!(values.cancelada || values.status !== 'AVAILABLE' || values.criadoPorId !== authData.id);

  const onSave = () => {
    const erros = validate(values, createSchema);
    setErrors(erros);
    if (!erros) {
      if (values.id) updateProcedimentosNormas(values.id, values, saveCallback);
      else createProcedimentosNormas(values, saveCallback);
    }
  };

  const saveCallback = success => {
    if (success) onCloseLocal(true);
  };

  const onCloseLocal = (isSave) => {
    procedimentosNormasClearSelected();
    setErrors({});
    setValues(getDefaultValues());
    setCancelValues({});
    setCancelErrors({});
    onClose(isSave);
    onReload();
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const isAdmin = () => userRole === Roles.ADMIN || userRole === Roles.SUPER_ADMIN;
  const isDisabled = () => disabled;

  return (
    <>
      <DialogDefaultV2
        open={open}
        handlerCancel={() => onCloseLocal(false)}
        handlerConfirm={onSave}
        title="Procedimento e Norma"
        confirmMessage="Salvar"
        maxWidth="md"
        fullWidth
        readOnly={isDisabled()}
        headerAction={[
          {
            onClick: () => setOpenCancelar(true),
            title: 'Cancelar',
            show: isAdmin() && !!values.id && values.status === 'AVAILABLE',
          },
          {
            onClick: () => setOpenAceitar(true),
            title: 'Aceitar',
            show: !!values.id && values.status === 'AVAILABLE' && !values.cancelada && values.usuarioIds === authData.id,
          },
        ]}
      >
        <Grid container spacing={1} sx={{ mt: 0 }}>
          {values.cancelada && (
            <Grid size={{ xs: 12 }} sx={{ color: 'error.main', fontStyle: 'italic' }}>
              **** Procedimento e Norma cancelado por {values.canceladaPorNome} em {values.dataCanceladaValue}
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 6 }}>
            <InputV2
              isRequired
              error={errors && errors.title}
              label="Título"
              name="title"
              onChange={handleChange}
              value={values.title}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <DefaultSelectV2
              error={!!(errors && errors.status)}
              isRequired
              label="Status"
              name="status"
              showEmpty
              options={[
                { id: 'AVAILABLE', nome: 'Aguardando Confirmação' },
                { id: 'CANCEL', nome: 'Cancelado' },
                { id: 'ACCEPTED', nome: 'Confirmado' },
              ]}
              onSelect={event => setValues({ ...values, status: event.target.value })}
              value={values.status}
              disabled
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2 label="Criado Por" value={values.criadoPorNome} disabled />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <OptionSelectV2
              label="Módulo"
              codigo="PROCEDIMENTOS_NORMAS_MODULOS"
              isRequired
              error={errors && errors.moduloId}
              onSelect={moduloId => setValues({ ...values, moduloId })}
              value={values.moduloId}
              disabled={isDisabled()}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <OptionSelectV2
              label="Tipo de Serviço"
              codigo="TIPO_SERVICO"
              onSelect={tipoServicoId => {
                setValues({ ...values, tipoServicoId, subtipoId: null });
                setErrors({});
              }}
              value={values.tipoServicoId}
              disabled={isDisabled()}
            />
          </Grid>
          {tipoServicoTemSubtipo(values.tipoServicoId) && (
            <Grid size={{ xs: 12, sm: 4 }}>
              <OptionSelectV2
                label="Subtipo da Inspeção"
                codigo="NSIR_SUBTIPOS"
                parentId={values.tipoServicoId}
                onSelect={subtipoId => setValues({ ...values, subtipoId })}
                value={values.subtipoId}
                disabled={isDisabled()}
              />
            </Grid>
          )}
          <Grid size={{ xs: 12 }}>
            <UsuarioSelectV2
              label="Usuários"
              onSelect={usuarioIds => setValues({ ...values, usuarioIds })}
              ativo
              value={values.usuarioIds}
              isRequired
              error={!!(errors && errors.usuarioIds)}
              disabled={isDisabled()}
              multiSelect={!values.id}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <RichTextEditorV2
              label="Descrição"
              rows={4}
              value={values.descricao}
              onChange={descricao => setValues(prev => ({ ...prev, descricao }))}
              disabled={isDisabled()}
            />
          </Grid>
          {values.status === 'CANCEL' && (
            <>
              <Grid size={{ xs: 12, sm: 3 }}>
                <InputV2 label="Cancelada Por" value={values.canceladaPorNome} disabled />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <InputV2 label="Data de Cancelamento" value={values.dataCanceladaValue} disabled />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <InputV2
                  isRequired
                  error={errors && errors.justificativaCancelamento}
                  label="Justificativa de Cancelamento"
                  name="justificativaCancelamento"
                  onChange={handleChange}
                  placeholder="justificativaCancelamento"
                  value={values.justificativaCancelamento}
                  rows={4}
                  multiline
                  disabled
                />
              </Grid>
            </>
          )}
          <Grid size={{ xs: 12 }}>
            <ArquivoContainerV2
              arquivos={values.arquivos || []}
              onSave={arquivos => setValues({ ...values, arquivos })}
              disabled={isDisabled()}
            />
          </Grid>
        </Grid>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={openAceitar}
        useFullScreen={false}
        handlerCancel={() => setOpenAceitar(false)}
        handlerConfirm={() => {
          procedimentosNormasConfirmStatus(values.id, isSave => {
            if (isSave) {
              setOpenAceitar(false);
              onCloseLocal(isSave);
            }
          });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>Deseja realmente confirmar o Procedimento e Norma?</DialogContentText>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={openCancelar}
        useFullScreen={false}
        handlerCancel={() => setOpenCancelar(false)}
        handlerConfirm={() => {
          const errs = validate(cancelValues, cancelSchema);
          setCancelErrors(errs);
          if (!errs) {
            procedimentosNormasCancelStatus(values.id, cancelValues, isSave => {
              if (isSave) {
                setOpenCancelar(false);
                onCloseLocal(isSave);
              }
            });
          }
        }}
        title="Cancelamento do Procedimento e Norma"
        confirmMessage="Confirmar"
        cancelMessage="Cancelar"
      >
        <Grid container spacing={1} sx={{ mt: 0 }}>
          <Grid size={{ xs: 12 }}>
            <InputV2
              isRequired
              error={cancelErrors && cancelErrors.justificativaCancelamento}
              label="Justificativa de Cancelamento"
              name="justificativaCancelamento"
              onChange={event => setCancelValues({ justificativaCancelamento: event.target.value })}
              placeholder="justificativaCancelamento"
              value={cancelValues.justificativaCancelamento}
              rows={4}
              multiline
            />
          </Grid>
        </Grid>
      </DialogDefaultV2>
    </>
  );
};

Formulario.propTypes = {
  createProcedimentosNormas: PropTypes.func.isRequired,
  updateProcedimentosNormas: PropTypes.func.isRequired,
  findProcedimentosNormasById: PropTypes.func.isRequired,
  procedimentosNormasClearSelected: PropTypes.func.isRequired,
  procedimentosNormasCancelStatus: PropTypes.func.isRequired,
  procedimentosNormasConfirmStatus: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
};

Formulario.defaultProps = {
  id: null,
};

const mapStateToProps = state => ({
  selectedProcedimentosNormas: selectorsProcedimentosNormas.getSelectedProcedimentosNormas(state),
  authData: selectorsAuth.getAuth(state),
  userRole: selectorsAuth.getRole(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsProcedimentosNormas,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
